import CreateDocumentDialog from './CreateDocumentDialog';

export default CreateDocumentDialog;
